import { useQuery } from '@tanstack/react-query';
import * as Routes from 'modules/routes';
import axios from 'axios';
import { UnitTagValues } from '../types';

type UnitTagValuesTypes = {
  programId: number,
  unitId: number,
  tagId: number;
  isEnabled: boolean,
};

const useUnitTagValues = ({ programId, unitId, tagId, isEnabled }: UnitTagValuesTypes) => {
  const path = Routes.plato_api_unit_tag_values_tags_path({
    program_id: programId,
    tag_id: tagId,
    unit_id: unitId,
  });

  const query = useQuery(['unit_tag_content', programId, unitId, tagId], () => (
    axios
      .get<UnitTagValues>(path)
      .then(res => res.data)
      // eslint-disable-next-line no-console
      .catch(err => console.error(err))
  ), { enabled: isEnabled, staleTime: Infinity });

  return { ...query, data: query.data || {} as UnitTagValues };
};

export default useUnitTagValues;
